import ServiceGraphQL from 'src/service/gql-service';
import { getInvoice } from 'src/graphql';

const serviceGraphQL = new ServiceGraphQL();

/** Action creators */
export const GetInvoice = (id) => {
  const params = {
    query: getInvoice.QUERY,
    variables: {
      filter: {
        _id: id
      }
    }
  };
  return serviceGraphQL
    .post(params)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};
